module.exports = __webpack_public_path__ + "static/media/Scotland.40146679.png";